import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Fallback for unmatched routes — avoids an empty shell when SMS/email links go stale/wrong.
 */
function NotFound() {
  const location = useLocation();
  const { currentUser } = useAuth();
  const driverHome = '/driver/ride-requests';
  const riderHome = '/rider/dashboard';
  const isDriverLike = location.pathname.startsWith('/driver');

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 py-16">
      <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wide">404</p>
      <h1 className="mt-2 text-3xl font-bold text-gray-900 text-center">Page not found</h1>
      <p className="mt-3 max-w-md text-center text-gray-600">
        We couldn’t find{' '}
        <code className="text-sm bg-gray-100 px-1.5 py-0.5 rounded text-gray-800 break-all">
          {location.pathname}
        </code>
        .
      </p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 flex-wrap justify-center">
        <Link
          to="/"
          className="inline-flex justify-center px-5 py-2.5 rounded-md border border-transparent text-white bg-indigo-600 hover:bg-indigo-700 font-medium"
        >
          Back to home
        </Link>
        <Link
          to="/login"
          className="inline-flex justify-center px-5 py-2.5 rounded-md border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 font-medium"
        >
          Sign in
        </Link>
        {currentUser?.userType === 'driver' && (
          <Link
            to={driverHome}
            className="inline-flex justify-center px-5 py-2.5 rounded-md border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 font-medium"
          >
            Ride requests
          </Link>
        )}
        {!currentUser && isDriverLike && (
          <Link
            to={driverHome}
            className="inline-flex justify-center px-5 py-2.5 rounded-md border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 font-medium"
          >
            Driver ride requests (after login)
          </Link>
        )}
        {currentUser?.userType === 'rider' && (
          <Link
            to={riderHome}
            className="inline-flex justify-center px-5 py-2.5 rounded-md border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 font-medium"
          >
            Rider dashboard
          </Link>
        )}
      </div>
    </div>
  );
}

export default NotFound;
